import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import {
  NgbDate,
  NgbCalendar,
  NgbDatepickerModule,
  NgbModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { FlatpickrDefaults, FlatpickrModule } from "angularx-flatpickr";
import { ConsentimientoService } from "src/app/core/services/consentimiento.service";
import { ApisService } from "src/app/core/services/apis.service";
import { SharedModule } from "src/app/shared/shared.module";
import Swal from "sweetalert2";
import { NgxMaskDirective, NgxMaskPipe } from "ngx-mask";
import { RouterModule } from "@angular/router";
import { PacientesService } from "src/app/core/services/paciente.service";
import { epsServices } from "src/app/core/services/eps.services";
import { Router } from "@angular/router";
import { ReferidosService } from "src/app/core/services/referidos.services";

@Component({
  selector: "app-consentimiento",
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    NgbDatepickerModule,
    FlatpickrModule,
    RouterModule,
  ],
  providers: [
    {
      provide: FlatpickrDefaults,
      useValue: {
        dateFormat: "Y-m-d",
        // Aquí puedes añadir más configuraciones por defecto si lo necesitas
      },
    },
  ],
  templateUrl: "./consentimiento.component.html",
  styleUrl: "./consentimiento.component.scss",
})
export class ConsentimientoComponent implements OnInit {
  loading = true;
  success = "";
  error: string;
  mensaje: string;
  debugMode = true; // Set to false in production
  formConsentimiento: FormGroup;
  tiposDocumento = [];
  eps = [];
  submitted = false;
  paises: any = [];
  departamentos: any = [];
  ciudades: any = [];
  tieneconsentimiento: boolean = false;
  currentUser: any;
  paciente: any;
  ubicacion: any;
  referidos = [];
  // FECHA
  currentDate: Date = new Date();
  formattedDate: string = "";
  storedDateFormat: string = "";

  constructor(
    private __apisService: ApisService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private __consentimientoService: ConsentimientoService,
    private __pacientesService: PacientesService,
    private __eps: epsServices,
    private router: Router,
    private __referidosService: ReferidosService
  ) {}
  // ###############################################################################################
  async ngOnInit(): Promise<void> {
    // FORMATO DE FECHA
    this.formattedDate = this.formatDateForDisplay(this.currentDate);
    this.storedDateFormat = this.formatDateForStorage(this.currentDate);

    const currentUser = localStorage.getItem("currentPatient");
    if (currentUser) {
      this.currentUser = JSON.parse(currentUser);

      // VALIDAR QUE NO TENGA CONSENTIMIENTO INFORMADO
      const tieneConsentimiento = await this.getConsentimiento(
        this.currentUser.userId
      );

      // console.log("tieneConsentimiento",tieneConsentimiento);
      if (tieneConsentimiento) {
        this.mensaje = "Ya tienes firmado el Consentimiento Informado";
        // Acciones adicionales si tiene consentimiento
      } else {
        this.mensaje = "";
        // Acciones adicionales si no tiene consentimiento
      }
      this.mensaje = "";
      this.getDataPaciente(this.currentUser.userId);
    } else {
      // NO HA INICIADO SESISIÓN SERA REDIRIGIDO AL INICIO
      window.location.href = "/";
    }

    // ###############################################################################################

    this.formConsentimiento = this.fb.group({
      idEps: [],
      nombres: [],
      documento: [],
      // genero: ['M', Validators.required],
      sexo: ["M", Validators.required],
      idPaciente: [],

      eInterdisciplinario: [null, Validators.required],
      slaboral: [null, Validators.required],
      derechos: [null, Validators.required],
      aceptoRiesgos: [null, Validators.required],
      aceptoCondiciones: [null, Validators.required],
      notas: [],
      tReferido: [],
    });

    this.getEps();
    this.getReferidos();
  }

  // Obtiene listado de la forma que fue referido el paciente
  getReferidos() {
    this.__referidosService.getTiposReferidos().then((data) => {
      this.referidos = data.documents;
    });
  }

  // ###############################################################################################
  getDataPaciente(userId) {
    this.loading = true;
    this.error = "";

    this.__pacientesService
      .getDocument(userId)
      .then((res: any) => {
        this.getCity(res.idCiudadResidencia);
        this.paciente = res;
      })
      .catch((err) => {
        this.error = "Error al cargar los datos del paciente: " + err.message;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  //#############################################################################################

  async getConsentimiento(userId: string): Promise<boolean> {
    try {
      const res = await this.__consentimientoService.getConsentimiento(userId);
      return res.length > 0;
    } catch (error) {
      console.error("Error al obtener el consentimiento:", error);
      return false;
    }
  }

  // ###############################################################################################
  createFirmaConsentimiento() {
    this.error = "";
    this.submitted = true;

    if (this.formConsentimiento.invalid) {
      this.error = "Por favor, completa todos los campos requeridos.";
      return;
    }
    // VALIDAR MENSAJE
    Swal.fire({
      icon: "warning",
      title: "Estas seguro de firmar el Consentimiento Informado?",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: "Estoy seguro",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        // Actualiza datos del paciente, ideps y sexo
        const data = {
          idEps: this.formConsentimiento.value.idEps,
          sexo: this.formConsentimiento.value.sexo,
        };
        // adicionar el idPaciente
        this.formConsentimiento.value.idPaciente = this.currentUser.userId;
        // adicionar al formulario nombres
        this.formConsentimiento.value.nombres =
          this.paciente.nombres + " " + this.paciente.apellidos;
        // adicionar al formulario documento
        this.formConsentimiento.value.documento = this.paciente.identificacion;
        // Remover del formulario idEps
        delete this.formConsentimiento.value.idEps;
        // Remover del formulario sexo
        delete this.formConsentimiento.value.sexo;

        this.__consentimientoService
          .createDocument(this.formConsentimiento.value)
          .then((res: any) => {
            // Actualiza datos del paciente
            this.__pacientesService
              .updateDocument(this.currentUser.userId, data)
              .then((res: any) => {
                Swal.fire({
                  icon: "success",
                  title:
                    "Se ha firmado exitosamente el Consentimiento Informado!",
                  showConfirmButton: false,
                  timer: 1500,
                });
                // Redireccionar al inicio de la aplicación con router
                this.router.navigate(["/"]);
              })
              .catch((error) => {
                console.log("error", error);
              });
          });
      }
    });
  }

  get form() {
    return this.formConsentimiento.controls;
  }

  getEps() {
    this.__eps.getEps().then((data) => {
      this.eps = data.documents;
    });
  }

  // CIUDAD
  getCity(idCity) {
    this.__apisService.getCity(idCity.toString()).subscribe((result) => {
      this.ubicacion = result;
    });
  }

  // FORMATEO DE FECHAS
  formatDateForDisplay(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("es-ES", options);
  }

  formatDateForStorage(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
}
